import React from 'react'

export default function LanguageSelector({languages, selected, handler}) {

    const rounded = (i) => {
        if(i === 0) return "rounded-start"
        if(i === (languages.length-1)) return "rounded-end"
        return "rounded"
    }

  return (
    <div>
        <p>Sprache wählen / Choose language /  إختيار اللغة</p>
        <div className='d-flex flex-row justify-content-center'>
        {languages.map((l,i) => {
            return (
                <button
                key={`btn_${i}`}
                onClick={()=>{handler(l.code)}}
                style={{width:"33%", borderCollapse:"collapse"}}
                className={` btn btn-lg btn${selected===l.code?"-primary":"-outline-secondary"} rounded-0 ${rounded(i)}`}>{l.label}</button>
            )
        })}
        </div>
    </div>
  )
}
